import $ from "jquery";
// Replace ® with <sup>&reg;</sup>;
$("h1, h2, h3, h4, h5, h6, p, a, .footer__reference, .text li").each(function () {
  var text = $(this).html();
  var text = text.replace(/®/g, "<sup>&reg;</sup>");
  $(this).html(text);
});


// WEBPACK FOOTER //
// ./assets/js/utilities/register-trademark.js